import React from "react";

// Generic table skeleton
export const TableSkeleton = ({ rows = 5, cols = 5 }) => (
  <div className="skeleton-table-wrap">
    <table className="table table-bordered">
      <thead>
        <tr>
          {Array(cols).fill(0).map((_, i) => (
            <th key={i}><div className="skeleton-box" style={{ height: "16px", borderRadius: "4px", background: "linear-gradient(90deg,#e0e0e0 25%,#f5f5f5 50%,#e0e0e0 75%)", backgroundSize: "200% 100%", animation: "shimmer 1.2s infinite" }}></div></th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array(rows).fill(0).map((_, r) => (
          <tr key={r}>
            {Array(cols).fill(0).map((_, c) => (
              <td key={c}><div className="skeleton-box" style={{ height: "14px", borderRadius: "4px", background: "linear-gradient(90deg,#e0e0e0 25%,#f5f5f5 50%,#e0e0e0 75%)", backgroundSize: "200% 100%", animation: "shimmer 1.2s infinite", animationDelay: `${c * 0.05}s` }}></div></td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
    <style>{`@keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }`}</style>
  </div>
);

// Card/KPI skeleton
// Mirrors the flat .stat-card layout — a quiet label above a single figure.
export const CardSkeleton = ({ count = 8 }) => (
  <div className="row">
    {Array(count).fill(0).map((_, i) => (
      <div key={i} className="col-xl-3 col-lg-4 col-sm-6 mb-3">
        <div className="stat-card">
          <div className="mb-2"><div style={{ height: "10px", width: "55%", borderRadius: "4px", background: "linear-gradient(90deg,#eceff3 25%,#f7f8fa 50%,#eceff3 75%)", backgroundSize: "200% 100%", animation: "shimmer 1.2s infinite" }}></div></div>
          <div style={{ height: "24px", width: "75%", borderRadius: "4px", background: "linear-gradient(90deg,#eceff3 25%,#f7f8fa 50%,#eceff3 75%)", backgroundSize: "200% 100%", animation: "shimmer 1.2s infinite", animationDelay: "0.1s" }}></div>
          <style>{`@keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }`}</style>
        </div>
      </div>
    ))}
  </div>
);

// Form skeleton
export const FormSkeleton = ({ fields = 4 }) => (
  <div>
    {Array(fields).fill(0).map((_, i) => (
      <div key={i} className="form-group mb-3">
        <div className="skeleton-box mb-1" style={{ height: "12px", width: "30%", borderRadius: "4px", background: "linear-gradient(90deg,#e0e0e0 25%,#f5f5f5 50%,#e0e0e0 75%)", backgroundSize: "200% 100%", animation: "shimmer 1.2s infinite" }}></div>
        <div className="skeleton-box" style={{ height: "38px", width: "100%", borderRadius: "4px", background: "linear-gradient(90deg,#e0e0e0 25%,#f5f5f5 50%,#e0e0e0 75%)", backgroundSize: "200% 100%", animation: "shimmer 1.2s infinite", animationDelay: `${i * 0.08}s` }}></div>
      </div>
    ))}
    <style>{`@keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }`}</style>
  </div>
);

// Chart skeleton
export const ChartSkeleton = ({ height = "300px" }) => (
  <div className="skeleton-box" style={{ height, width: "100%", borderRadius: "8px", background: "linear-gradient(90deg,#e0e0e0 25%,#f5f5f5 50%,#e0e0e0 75%)", backgroundSize: "200% 100%", animation: "shimmer 1.2s infinite" }}>
    <style>{`@keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }`}</style>
  </div>
);

export default TableSkeleton;
